/*
*   Genera un numero intero compreso tra [ min, ... , max )
*   => se max non viene indicato viene generato un intero compreso tra [ 0, ..., max )
*   => se max e min non vengono indicati viene generato un intero tra [ 0 , 1 ]
*/
function generateInt(min, max){
    if( typeof min === 'undefined' && typeof max === 'undefined' ){
        min = 0;
        max = 1;
    }else if( typeof max === 'undefined' ){
        max = min || 1;
        min = 0;
    }
    min = min || 0;
    return parseInt( Math.random() * (max - min) + min );
}

/*
*   Viene generata una sequenza di almeno 4 caratteri
*/
export function generatePsw(min = 4, max){
	const specials   = '!@#$%^&*()_+{}:"<>?[];\',./';
	const lowercase  = 'abcdefghijklmnopqrstuvwxyz';
	const uppercase  = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
	const numbers    = '0123456789';
    const characters = specials + lowercase + uppercase + numbers;
    //Genero la lunghezza della password
    if(typeof max === 'undefined')	max = min;
    var pswLength = generateInt(min, max || 4);
    //Costruisco la password
    var psw = "";
    pswLength -= 4; //Elimino quelli che inserisco manualmente
    psw += lowercase[generateInt(lowercase.length)];
    psw += numbers[generateInt(numbers.length)];
    for( var i = 0 ; i<pswLength; i++ ) psw+=characters[generateInt(characters.length)];
    psw += specials[generateInt(specials.length)];
    psw += uppercase[generateInt(uppercase.length)];
    return psw;
}


// WEBPACK FOOTER //
// ./src/Utils/PwsUtils.js